import useOnlineStatus from '../hooks/useOnlineStatus'
import { Icon } from './Icon'

// ── OfflineBanner ────────────────────────────────────────────────────────
// Fixed-top banner that appears whenever the browser reports offline.
// Self-contained: no props, no context — just mount it once at the app root.
//
// The banner uses position:fixed so it overlays any page without forcing
// layout changes. On small screens it wraps naturally; on large ones it
// stays as a single compact strip. Z-index is higher than modal drawers
// (99 is our modal ceiling elsewhere) so it's always visible.
export default function OfflineBanner() {
  const online = useOnlineStatus()
  if (online) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#B84A4A',
        color: '#fff',
        padding: '8px 16px',
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "'Outfit', sans-serif",
        textAlign: 'center',
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      }}
    >
      <span style={{ marginRight: 6, verticalAlign: 'middle', display: 'inline-flex' }} aria-hidden="true"><Icon name="alert-triangle" size={14} /></span>
      You're offline. Some features may be unavailable until your connection returns.
    </div>
  )
}
